import React, { useMemo, useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { publicRoute, userRoute, adminRoute } from './AllRoutes';
import Layout from './Layout';
import { useSelector, useDispatch } from 'react-redux';
import { routeConstant } from './RouteConstant';
import { BrowserRouter } from 'react-router-dom';
import { roleEnum, adminEnum } from 'shared/utils/Enum';
import { GetPublicRoleDetailQuery } from 'shared/services/role_service/RoleService';
import { deepCopy } from 'shared/utils/Helper';
import { setUser } from 'shared/redux/reducers/UserSlice';
import { setPermissionRole } from 'shared/redux/reducers/PermissionRouteSlice';

function AuthRoute() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.root);
    const [privateRouteList, setPrivateRouteList] = useState(adminRoute);
    const { data: RoleData, isSuccess: RoleIsSuccess } = GetPublicRoleDetailQuery(user?.user?.role?._id);
    useEffect(() => {
        let accessPermission = user?.user?.role;
        let cloneUser = deepCopy(user);
        let findUpdateRole = RoleData?.find((ii) => ii?._id === accessPermission?._id);

        if (findUpdateRole) {
            cloneUser.user.role = findUpdateRole;
            accessPermission = findUpdateRole;
            dispatch(setUser(cloneUser));
        }

        let accessPermissionRoute = ['dashboard'];

        // Super Admin gets direct access to everything
        if (accessPermission?.name === adminEnum.superAdmin) {
            setPrivateRouteList(adminRoute);
            const allPaths = adminRoute.map(r => r.path.split('/')[1] || r.path.split('/')[2]).filter(Boolean);
            dispatch(setPermissionRole({ RoutelistPath: [...new Set([...accessPermissionRoute, ...allPaths])] }));
            return;
        }

        if (accessPermission) {
            Object.entries(accessPermission).forEach(([key, value]) => {
                if (value?.view || value?.create || value?.update || value?.delete) {
                    accessPermissionRoute.push(key);
                }
            });
        }

        accessPermissionRoute = [...new Set(accessPermissionRoute)];

        let permissionRoute = adminRoute.filter((ii) => {
            const pathKey = ii.path.split('/')[1] || ii.path.split('/')[2];
            return accessPermissionRoute.includes(pathKey);
        });

        dispatch(setPermissionRole({ RoutelistPath: accessPermissionRoute }));
        setPrivateRouteList(permissionRoute);
    }, [RoleData, user.isLoggedIn, user?.user?.role]);
    return (
        <BrowserRouter>
            <Routes>
                {!user?.isLoggedIn
                    ? publicRoute.map((route, inx) => {
                        return (
                            <React.Fragment key={inx}>
                                <Route path={route.path} key={inx} element={<Layout {...route} />} />
                                <Route path={'*'} element={<Navigate to="/" replace />} />
                            </React.Fragment>
                        );
                    })
                    : (
                        <>
                            {[
                                ...(user?.user?.authorize == roleEnum.admin ? [] : userRoute),
                                ...privateRouteList
                            ].map((route, inx) => {
                                return (
                                    <Route path={route.path} key={inx} element={<Layout {...route} />} />
                                );
                            })}
                            <Route
                                path={'*'}
                                element={
                                    <Navigate
                                        to={user?.user?.authorize == roleEnum.admin ? routeConstant.admin.dashboard.path : routeConstant.user.task.path}
                                        replace
                                    />
                                }
                            />
                        </>
                    )}
            </Routes>
        </BrowserRouter>
    );
}

export default AuthRoute;
